<section class="container-style">
  <form [formGroup]="formInventoryClass">
    <div class="row">
      <div class="col-lg-3 col-md-4 col-sm-4 col-12">
        <app-custom-input-text formControlName="code" [labelText]="'Código'" [required]="true" [recovery]="true"
          (onChangeText)="changeInventoryClass()">
        </app-custom-input-text>
      </div>
      <div class="col-lg-9 col-md-8 col-sm-8 col-12">
        <app-custom-input-text formControlName="name" [required]="true" [labelText]="'Nombre'">
        </app-custom-input-text>
      </div>
      <div class="col-lg-12 col-md-12 col-sm-12 col-12 d-flex justify-content-between align-items-end mt-2 mt-md-3">
        <app-custom-button class="button-new-register" [title]="'Nuevo'" [label]="'Nuevo'" [severity]="'success'"
          [icon]="'pi pi-plus'" [width]="'5.5rem'" [variant]="undefined"
          (onClick)="createNewInventoryClass()"></app-custom-button>

        <app-custom-button [label]="'Guardar'" [severity]="'primary'" [variant]="undefined"
          (onClick)="send()"></app-custom-button>
      </div>
    </div>
  </form>
</section>